import { render, staticRenderFns } from "./ViEnrollSchoolView.vue?vue&type=template&id=c2c7448e"
import script from "./ViEnrollSchoolView.vue?vue&type=script&lang=js"
export * from "./ViEnrollSchoolView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports